import { type ClassValue, clsx } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

export const twMergeConfig = {
  extend: {
    classGroups: {
      // Create separate group for custom <property> to avoid conflicts with other properties
      color: [
        'white',
        'page-background',
        'page-content-container',
        'surface-lowest',
        'surface-low',
        'surface-container',
        'surface-container-high',
        'surface-container-highest',
        'outline',
        'outline-medium',
        'outline-dark',
        'primary-new',
        'primary-hover',
        'on-primary',
        'primary-container',
        'on-primary-container',
        'secondary-new',
        'secondary-hover',
        'on-secondary',
        'secondary-container',
        'on-secondary-container',
        'tertiary',
        'on-tertiary',
        'error',
        'error-hover',
        'on-error',
        'error-container',
        'on-error-container',
        'success',
        'success-hover',
        'on-success',
        'success-container',
        'on-success-container',
        'warning',
        'warning-hover',
        'on-warning',
        'warning-container',
        'on-warning-container',
        'purple',
        'on-purple',
        'teal',
        'on-teal',
        'yellow',
        'on-yellow',
        'green',
        'on-green',
        'red',
        'on-red',
        'focus',
        'heading',
        'paragraph',
        'subheading',
        'supporting',
      ],
    },
  },
} as Parameters<typeof extendTailwindMerge>[0];

const customTwMerge = extendTailwindMerge(twMergeConfig);

/**
 * Combines multiple class name inputs into a single, optimized string.
 *
 * This function first uses `clsx` to conditionally join class names from various inputs (strings, arrays, or objects).
 * It then applies `twMerge` to intelligently merge and resolve TailwindCSS-specific class conflicts.
 *
 * @param inputs - Class name values that may include conditional or grouped entries.
 * @returns A merged class name string optimized for TailwindCSS.
 *
 * @example
 * cn("p-4", { "bg-red-500": isActive }, ["flex", "justify-center"])
 * // Returns a string with properly merged Tailwind classes.
 */
export function cn(...inputs: ClassValue[]) {
  return customTwMerge(clsx(inputs));
}
